import {
  VirtualBackgrounds as VirtualBackgroundsStateless,
  type VirtualBackgroundsProps as VirtualBackgroundsStatelessProps,
} from '../../call/virtualBackgrounds';
import { withState } from '../../../shared/withState';
import { useVirtualBackgroundState } from './useVirtualBackgroundState';

export const VirtualBackground = withState<VirtualBackgroundsStatelessProps>(
  useVirtualBackgroundState,
  VirtualBackgroundsStateless,
);
